import React, { useContext } from 'react';

import styled from '@emotion/styled';

import PrimaryButton from '../../../components/Button/PrimaryButton';
import { ModalContext } from '../../../context/ModalContext';

const CreateDispatcher = () => {
  const modalContext = useContext(ModalContext);

  const createDispatcherHandler = (e: any) => {
    modalContext?.displayModal(true);
  };

  return (
    <Container>
      <Label>Dispatcher</Label>
      <PrimaryButton className="fitContent" onClick={createDispatcherHandler}>
        Create Dispatcher
      </PrimaryButton>
    </Container>
  );
};

export default CreateDispatcher;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  justify-content: space-between;
  align-items: center;
`;

const Label = styled.h1`
  color: #2c2421;
  font-size: 1.25rem;
  font-weight: 700;
`;
